import styled from "styled-components";

const SliceProcessPanelStyled = styled.div`

`;

export default SliceProcessPanelStyled;